import isDraftProduct from "./isDraftProduct";

let omsId;
const url = typeof window !== 'undefined' ? window?.location?.href : '';

if (isDraftProduct) {
  omsId = url.match(/\?draftProductId=([0-9]+)\&?/i)[1];
} else {
  const urlOmsId = url.match(/[0-9]{9}/g);
  const anchorSku = url.match(/\?omsid=([0-9]+)\&?/i);
  omsId = anchorSku ? anchorSku[1] : urlOmsId ? urlOmsId[0] : null;
}

export default omsId ;
